$(function () {
        let $button = $('a[data-modal=true][data-eula=true]')
        let $modals = $('.eula-modal');

        if ($modals.length > 0) {
            let $modal_btn = $('.modal-redirect')
            let $modal = '';

            $button.on('click', function (e) {
                e.preventDefault();

                let $type = $(this).attr('data-type');

                if ($modals.length > 1) {
                    $modal = $modals.filter(function () {
                        return $(this).attr('data-type') === $type
                    });
                } else {
                    $modal = $modals;
                }

                $modal.find('.btn').prop('href', e.currentTarget.href)

                $modal = bootstrap.Modal.getOrCreateInstance($modal);
                $modal.show()
            })

            $modal_btn.on('click', function (e) {
                $modal.hide()
            })

            if ($modals.length > 1) {
                $modals.each(function (index, value) {
                    acceptEula(value);
                })
            } else {
                acceptEula($modals);
            }
        }

        /**
         * Gets input and submit button and uncheck on pressed
         * @param $modal
         */
        function acceptEula($modal) {
            let $this = $($modal);

            let $modal_btn = $this.find('a.modal-redirect');
            let $modal_check = $this.find('input.acceptance-check');

            //Init to uncheck
            $modal_btn.addClass("disabled");
            $modal_check.prop("checked", false);

            $modal_check.on('click', function () {
                if ($(this).is(':checked')) {
                    $modal_btn.removeClass("disabled");
                } else {
                    $modal_btn.addClass("disabled");
                }
            })

            //Uncheck on hide modal
            $this[0].addEventListener('hidden.bs.modal', function () {
                $modal_check.prop("checked", false);
                $modal_btn.addClass("disabled");
            })
        }
    }
);
